export default __webpack_public_path__ + "img/74562f49aab3743d38431a1b66bb4175.svg";